import { render } from "./RiskLegend.vue?vue&type=template&id=0f4d5ae0&scoped=true"
import script from "./RiskLegend.vue?vue&type=script&lang=js"
export * from "./RiskLegend.vue?vue&type=script&lang=js"

import "./RiskLegend.vue?vue&type=style&index=0&id=0f4d5ae0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4d5ae0"]])

export default __exports__